(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cc-badge-confiance"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__ccSocialProofSmoothScrollBound) return;
    window.__ccSocialProofSmoothScrollBound = true;

    document.addEventListener('click', (event) => {
      const link = event.target.closest('.cc-social-proof__link');
      if (!link) return;

      let destination;
      try {
        destination = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      const isSameDocument =
        destination.origin === window.location.origin &&
        destination.pathname === window.location.pathname &&
        destination.search === window.location.search;

      if (!isSameDocument || !destination.hash) return;

      let targetId = destination.hash.slice(1);
      try {
        targetId = decodeURIComponent(targetId);
      } catch (error) {
        // Conserve l'identifiant brut si l'ancre n'est pas encodée correctement.
      }

      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();

      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start',
      });

      if (window.location.hash !== destination.hash) {
        window.history.pushState(null, '', destination.hash);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cc-compteur"] && !Shopify.designMode) return;
  try {
    class CcPurchaseCounter extends HTMLElement {
    #timer;

    connectedCallback() {
      window.clearInterval(this.#timer);

      const valueElement = this.querySelector('[data-counter-value]');
      const start = Number.parseInt(this.dataset.start || '0', 10);
      const intervalMinutes = Number.parseFloat(this.dataset.intervalMinutes || '0');

      if (!valueElement || !Number.isFinite(start)) return;

      let currentValue = Math.max(0, start);
      const locale = document.documentElement.lang || 'fr';
      const formatter = new Intl.NumberFormat(locale);
      const render = () => {
        valueElement.textContent = formatter.format(currentValue);
      };

      render();

      if (!Number.isFinite(intervalMinutes) || intervalMinutes <= 0) return;

      this.#timer = window.setInterval(() => {
        currentValue += 1;
        render();
      }, intervalMinutes * 60 * 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.#timer);
    }
  }

  if (!customElements.get('cc-purchase-counter')) {
    customElements.define('cc-purchase-counter', CcPurchaseCounter);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cc-prix"] && !Shopify.designMode) return;
  try {
    /**
   * Reduit la taille du texte du badge de reduction jusqu'a ce qu'il tienne
   * dans ses bordures. N'agit que si data-fit vaut true, c'est-a-dire quand
   * l'option « forcer le badge sur la meme ligne » est cochee.
   */
  class CcBadgeFit extends HTMLElement {
    #observer;
    #lastWidth = -1;

    connectedCallback() {
      if (this.dataset.fit !== 'true') return;

      this.#observer = new ResizeObserver(() => this.#schedule());
      if (this.parentElement) this.#observer.observe(this.parentElement);
      this.#schedule();
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }

    /**
     * Ignore les notifications qui ne changent pas la largeur disponible : c'est
     * ce garde-fou qui evite une boucle avec le ResizeObserver, puisque changer
     * la taille du texte change la hauteur de la ligne. Le calcul est synchrone
     * et non differe par requestAnimationFrame, sinon un onglet ouvert en
     * arriere-plan afficherait un badge tronque jusqu'au premier redimensionnement.
     */
    #schedule() {
      const width = this.parentElement?.clientWidth ?? 0;
      if (width === this.#lastWidth) return;
      this.#lastWidth = width;
      this.#fit();
    }

    #fit() {
      const text = this.querySelector('.cc-price-row__badge-text');
      const row = this.closest('.cc-price-row');
      if (!text || !row) return;

      const max = Number.parseFloat(this.dataset.maxSize || '12');
      const min = Number.parseFloat(this.dataset.minSize || '8');
      if (!Number.isFinite(max) || !Number.isFinite(min)) return;

      // Etat neutre avant de mesurer, sinon on mesure le resultat precedent.
      row.classList.remove('cc-price-row--badge-wrapped');
      this.style.fontSize = `${max}px`;

      const styles = window.getComputedStyle(this);
      const paddings = Number.parseFloat(styles.paddingLeft) + Number.parseFloat(styles.paddingRight);
      const available = this.clientWidth - paddings;
      const natural = text.getBoundingClientRect().width;

      if (!(available > 0) || !(natural > 0) || natural <= available) return;

      const required = (max * available) / natural;

      if (required < min) {
        // Meme a la taille minimale le texte serait coupe : mieux vaut le
        // laisser passer sous le prix qu'afficher un badge tronque.
        row.classList.add('cc-price-row--badge-wrapped');
        this.style.fontSize = '';
        return;
      }

      this.style.fontSize = `${Math.floor(required * 10) / 10}px`;
    }
  }

  if (!customElements.get('cc-badge-fit')) {
    customElements.define('cc-badge-fit', CcBadgeFit);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["toneaglow-video-bubbles"] && !Shopify.designMode) return;
  try {
    (function () {
    function initBlock(root) {
      if (!root || root.dataset.tvbInitialized === 'true') return;
      root.dataset.tvbInitialized = 'true';

      var dialog = root.querySelector('.toneaglow-video-bubbles__modal');
      var player = dialog ? dialog.querySelector('[data-tvb-player]') : null;
      if (!dialog || !player) return;

      var isCardLayout = root.getAttribute('data-layout') === 'cards';
      var shouldLoop = root.getAttribute('data-loop-videos') === 'true';
      var previewVideos = Array.from(root.querySelectorAll('[data-tvb-preview], [data-tvb-card-video]'));
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var desktopMedia = window.matchMedia('(min-width: 750px)');
      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      var track = root.querySelector('[data-tvb-track]');
      var previousButton = root.querySelector('[data-tvb-previous]');
      var nextButton = root.querySelector('[data-tvb-next]');
      var cardElements = Array.from(root.querySelectorAll('[data-tvb-card]'));
      var previewObserver = null;
      var previewTimer = null;
      var activeTrigger = null;

      function autoPreviewsDisabled() {
        if (reduceMotion.matches) return true;
        if (!connection) return false;
        if (connection.saveData) return true;
        return connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g';
      }

      function clearPreviewTimer() {
        if (!previewTimer) return;
        window.clearTimeout(previewTimer);
        previewTimer = null;
      }

      function pausePreviews(hideVideo) {
        clearPreviewTimer();
        for (var video of previewVideos) {
          video.pause();
          if (hideVideo) video.classList.remove('is-playing');
        }
      }

      function playPreview(video) {
        if (!video || autoPreviewsDisabled() || dialog.open || document.hidden) return;
        video.muted = true;
        video.defaultMuted = true;
        video.loop = video.hasAttribute('data-tvb-card-video') || shouldLoop;
        if (!video.src) {
          video.src = video.getAttribute('data-src');
          video.load();
        }
        var playPromise = video.play();
        if (playPromise && playPromise.catch) playPromise.catch(function () {});
      }

      function scheduleVisiblePreviews() {
        if (autoPreviewsDisabled() || dialog.open || document.hidden) return;

        for (var video of previewVideos) {
          if (video.dataset.tvbInView === 'true' && video.src) playPreview(video);
        }

        if (previewTimer) return;
        var nextVideo = previewVideos.find(function (video) {
          return video.dataset.tvbInView === 'true' && !video.src;
        });
        if (!nextVideo) return;

        playPreview(nextVideo);
        previewTimer = window.setTimeout(function () {
          previewTimer = null;
          scheduleVisiblePreviews();
        }, 400);
      }

      for (var video of previewVideos) {
        video.addEventListener('playing', function (event) {
          event.currentTarget.classList.add('is-playing');
        });
      }

      function startPreviewObserver() {
        if (previewObserver || autoPreviewsDisabled() || !previewVideos.length) return;
        if (!('IntersectionObserver' in window)) {
          for (var video of previewVideos) video.dataset.tvbInView = 'true';
          scheduleVisiblePreviews();
          return;
        }
        previewObserver = new IntersectionObserver(function (entries) {
          for (var entry of entries) {
            entry.target.dataset.tvbInView = entry.isIntersecting ? 'true' : 'false';
            if (!entry.isIntersecting) entry.target.pause();
          }
          scheduleVisiblePreviews();
        }, { rootMargin: '80px 0px', threshold: 0.25 });
        for (var video of previewVideos) previewObserver.observe(video);
      }

      function handleAutoplayPreferenceChange() {
        if (autoPreviewsDisabled()) {
          if (previewObserver) previewObserver.disconnect();
          previewObserver = null;
          pausePreviews(true);
          return;
        }
        startPreviewObserver();
        scheduleVisiblePreviews();
      }

      function handleVisibilityChange() {
        if (document.hidden) pausePreviews(false);
        else scheduleVisiblePreviews();
      }

      function clearPlayer() {
        player.replaceChildren();
      }

      function openVideo(button) {
        var mp4 = button.getAttribute('data-mp4');
        if (!mp4 || isCardLayout) return;

        activeTrigger = button;
        pausePreviews(false);
        clearPlayer();

        var video = document.createElement('video');
        video.src = mp4;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        if (shouldLoop) {
          video.loop = true;
          video.setAttribute('loop', '');
        }

        var poster = button.getAttribute('data-poster');
        if (poster) video.poster = poster;
        player.appendChild(video);

        if (!dialog.open) {
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        }

        var playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(function () {
            video.muted = true;
            video.play().catch(function () {});
          });
        }
      }

      function closeVideo() {
        if (dialog.open && typeof dialog.close === 'function') {
          dialog.close();
          return;
        }
        dialog.removeAttribute('open');
        clearPlayer();
        scheduleVisiblePreviews();
        if (activeTrigger) activeTrigger.focus();
      }

      function visibleCardCount() {
        var value = desktopMedia.matches
          ? root.getAttribute('data-cards-desktop')
          : root.getAttribute('data-cards-mobile');
        return Math.max(1, parseInt(value, 10) || 1);
      }

      function cardScrollTargets() {
        if (!track) return [];
        var trackRect = track.getBoundingClientRect();
        return cardElements.map(function (card) {
          var item = card.closest('.toneaglow-video-item') || card;
          var wrapper = card.closest('.shopify-block');
          var element = wrapper && wrapper.getBoundingClientRect().width > 0 ? wrapper : item;
          return {
            element: element,
            left: element.getBoundingClientRect().left - trackRect.left + track.scrollLeft
          };
        });
      }

      function updateCarouselControls() {
        if (!previousButton || !nextButton) return;
        var shouldShow = isCardLayout && cardElements.length > visibleCardCount();
        previousButton.hidden = !shouldShow;
        nextButton.hidden = !shouldShow;
      }

      function scrollCarousel(direction) {
        if (!track || !cardElements.length) return;
        var targets = cardScrollTargets();
        var currentIndex = 0;
        var smallestDistance = Infinity;

        for (var index = 0; index < targets.length; index += 1) {
          var distance = Math.abs(targets[index].left - track.scrollLeft);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            currentIndex = index;
          }
        }

        var step = visibleCardCount();
        var maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        var targetIndex;

        if (direction > 0) {
          targetIndex = track.scrollLeft >= maximumScroll - 2 ? 0 : currentIndex + step;
          if (targetIndex >= targets.length) targetIndex = 0;
        } else {
          targetIndex = track.scrollLeft <= 2 ? Math.max(0, targets.length - step) : currentIndex - step;
          if (targetIndex < 0) targetIndex = 0;
        }

        track.scrollTo({
          left: Math.min(targets[targetIndex].left, maximumScroll),
          behavior: reduceMotion.matches ? 'auto' : 'smooth'
        });
      }

      function handlePreviousClick() {
        scrollCarousel(-1);
      }

      function handleNextClick() {
        scrollCarousel(1);
      }

      function handleViewportChange() {
        updateCarouselControls();
      }

      for (var button of root.querySelectorAll('[data-tvb-open]')) {
        button.addEventListener('click', function (event) {
          openVideo(event.currentTarget);
        });
      }

      for (var closeButton of dialog.querySelectorAll('[data-tvb-close]')) {
        closeButton.addEventListener('click', closeVideo);
      }

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeVideo();
      });

      dialog.addEventListener('close', function () {
        clearPlayer();
        scheduleVisiblePreviews();
        if (activeTrigger) activeTrigger.focus();
      });

      if (previousButton) previousButton.addEventListener('click', handlePreviousClick);
      if (nextButton) nextButton.addEventListener('click', handleNextClick);
      if (typeof desktopMedia.addEventListener === 'function') {
        desktopMedia.addEventListener('change', handleViewportChange);
      } else {
        desktopMedia.addListener(handleViewportChange);
      }

      updateCarouselControls();
      startPreviewObserver();
      if (typeof reduceMotion.addEventListener === 'function') {
        reduceMotion.addEventListener('change', handleAutoplayPreferenceChange);
      } else {
        reduceMotion.addListener(handleAutoplayPreferenceChange);
      }
      if (connection && typeof connection.addEventListener === 'function') {
        connection.addEventListener('change', handleAutoplayPreferenceChange);
      }
      document.addEventListener('visibilitychange', handleVisibilityChange);

      root.tvbDestroy = function () {
        if (previewObserver) previewObserver.disconnect();
        if (typeof reduceMotion.removeEventListener === 'function') {
          reduceMotion.removeEventListener('change', handleAutoplayPreferenceChange);
        } else {
          reduceMotion.removeListener(handleAutoplayPreferenceChange);
        }
        if (typeof desktopMedia.removeEventListener === 'function') {
          desktopMedia.removeEventListener('change', handleViewportChange);
        } else {
          desktopMedia.removeListener(handleViewportChange);
        }
        if (connection && typeof connection.removeEventListener === 'function') {
          connection.removeEventListener('change', handleAutoplayPreferenceChange);
        }
        if (previousButton) previousButton.removeEventListener('click', handlePreviousClick);
        if (nextButton) nextButton.removeEventListener('click', handleNextClick);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        pausePreviews(true);
        clearPlayer();
      };
    }

    function initAll() {
      for (var root of document.querySelectorAll('.toneaglow-video-bubbles')) initBlock(root);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.target || !event.target.querySelectorAll) return;
      for (var root of event.target.querySelectorAll('.toneaglow-video-bubbles')) {
        if (root.tvbDestroy) root.tvbDestroy();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["toneaglow-video-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('toneaglow-video-carousel')) {
    class ToneaglowVideoCarousel extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('[data-tgvc-track]');
        this.previous = this.querySelector('[data-tgvc-previous]');
        this.next = this.querySelector('[data-tgvc-next]');
        this.dialog = this.querySelector('[data-tgvc-dialog]');
        this.player = this.querySelector('[data-tgvc-dialog-video]');
        if (!this.track) return;
        this.items = [...this.track.querySelectorAll('[data-tgvc-item]')];
        this.videos = [...this.track.querySelectorAll('[data-tgvc-video]')];
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.updateArrows(), { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const item = event.target.closest('[data-tgvc-item]');
          if (!item || !this.track.contains(item)) return;
          this.track.scrollTo({ left: this.itemPosition(item), behavior: 'auto' });
        }, options);
        this.querySelector('[data-tgvc-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.player.pause();
          this.player.removeAttribute('src');
          this.player.load();
          this.opener?.focus({ preventScroll: true });
        }, options);
        const modal = this.dataset.playback === 'modal';
        for (const video of this.videos) {
          const card = video.closest('.tgvc__card');
          const play = card.querySelector('[data-tgvc-play]');
          const sound = card.querySelector('[data-tgvc-sound]');
          video.controls = false;
          video.tabIndex = -1;
          video.loop = this.dataset.loop === 'true';
          play.hidden = false;
          sound.hidden = modal;
          const toggle = () => {
            if (modal) {
              this.pauseOthers();
              this.opener = play;
              this.player.src = video.getAttribute('src');
              this.player.poster = video.poster;
              this.player.setAttribute('aria-label', video.getAttribute('aria-label'));
              this.player.loop = video.loop;
              this.player.muted = false;
              this.dialog.showModal();
              this.tryPlay(this.player);
              return;
            }
            if (!video.paused) { video.pause(); return; }
            this.pauseOthers(video);
            video.muted = false;
            this.tryPlay(video);
          };
          play.addEventListener('click', toggle, options);
          video.addEventListener('click', toggle, options);
          sound.addEventListener('click', () => {
            video.muted = !video.muted;
            if (!video.muted && video.paused) { this.pauseOthers(video); this.tryPlay(video); }
          }, options);
          const update = () => {
            card.classList.toggle('is-playing', !video.paused);
            play.setAttribute('aria-label', video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
            sound.setAttribute('aria-pressed', String(!video.muted));
          };
          for (const name of ['play', 'pause', 'ended', 'volumechange']) video.addEventListener(name, update, options);
          update();
        }
        this.visibility = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.intersectionRatio < 0.5) entry.target.querySelector('[data-tgvc-video]')?.pause();
          }
        }, { root: this.track, threshold: [0, 0.5] });
        for (const item of this.items) this.visibility.observe(item);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) { this.pauseOthers(); this.player.pause(); }
        }, options);
        this.resize = new ResizeObserver(() => this.updateArrows());
        this.resize.observe(this.track);
        this.updateArrows();
      }

      itemPosition(item) {
        return item.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
      }

      move(direction) {
        const positions = this.items.map((item) => this.itemPosition(item));
        const current = this.track.scrollLeft;
        const target = direction > 0
          ? positions.find((position) => position > current + 2)
          : positions.reverse().find((position) => position < current - 2);
        this.track.scrollTo({ left: target ?? (direction > 0 ? this.track.scrollWidth : 0),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }

      updateArrows() {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        this.previous.hidden = this.next.hidden = maximum <= 2;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= maximum - 2;
      }

      pauseOthers(except) {
        for (const video of this.videos) if (video !== except) video.pause();
      }

      async tryPlay(video) {
        try { await video.play(); } catch { /* Keep the play button available for another attempt. */ }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.resize?.disconnect();
        this.visibility?.disconnect();
        for (const video of this.videos || []) video.pause();
        this.player?.pause();
        if (this.dialog?.open) this.dialog.close();
      }
    }
    customElements.define('toneaglow-video-carousel', ToneaglowVideoCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
